import { AnnotationShape } from '@/web-components/import-wizard/typings';
import { checkIsInArea } from './collisionHelper';
import { useStore as useProductStore } from '@/stores/product';

const CORRECTION_FACTOR = 0;

export const alignLeftControl = (
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableAreaShapeType: string
): number => {
  const productStore = useProductStore();
  const printableArea = productStore.drawPoints();
  const printableAreaRotation = productStore.rotation;

  let isInRectangle = false;
  const idx = 2;
  let newX = printableArea.x - printableArea.w / 2;

  if (printableAreaShapeType === 'Rectangle') {
    while (isInRectangle === false) {
      newX = newX + idx;
      isInRectangle = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
    }
    return newX;
  } else if (printableAreaShapeType === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;

    while (isInEllipse === false) {
      //newX = printableArea.x - printableArea.rx + idx * CORRECTION_FACTOR;
      newX = printableArea.x - printableArea.rx + idx;
      isInEllipse = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newX;
  }

  return newX;
};

export const alignRightControl = (
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableAreaShapeType: string,
  actualWidth: number
): number => {
  const productStore = useProductStore();

  const printableArea = productStore.drawPoints();
  const printableAreaRotation = productStore.rotation;

  let isInRectangle = false;
  const idx = 2;
  let newX = productStore.drawPoints().x + productStore.drawPoints().w;

  if (printableAreaShapeType === 'Rectangle') {
    while (isInRectangle === false) {
      newX = newX - idx;
      isInRectangle = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
    }
    return newX;
  } else if (printableAreaShapeType === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;

    while (isInEllipse === false) {
      newX =
        productStore.drawPoints().x +
        productStore.drawPoints().rx * 2 +
        actualWidth -
        //idx * CORRECTION_FACTOR;
        idx;
      isInEllipse = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newX;
  }

  return newX;
};

export const alignTopControl = (
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableAreaShapeType: string
): number => {
  const productStore = useProductStore();

  const printableArea = productStore.drawPoints();
  const printableAreaRotation = productStore.rotation;
  let newY = 0;

  if (printableAreaShapeType === 'Rectangle') {
    let isInRectangle = false;
    let idx = 1;

    while (isInRectangle === false) {
      //newY = productStore.drawPoints().y + idx * CORRECTION_FACTOR;
      newY = productStore.drawPoints().y + idx;
      isInRectangle = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  } else if (printableAreaShapeType === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;
    while (isInEllipse === false) {
      newY =
        productStore.drawPoints().y -
        productStore.drawPoints().ry +
        //idx * CORRECTION_FACTOR;
        idx;
      isInEllipse = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  }

  return newY;
};

export const alignBottomControl = (
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableAreaShapeType: string,
  actualHeight: number
): number => {
  const productStore = useProductStore();
  const printableArea = productStore.drawPoints();
  const printableAreaRotation = productStore.rotation;
  let newY = 0;

  if (printableAreaShapeType === 'Rectangle') {
    let isInRectangle = false;
    let idx = 1;

    while (isInRectangle === false) {
      newY =
        productStore.drawPoints().y +
        productStore.drawPoints().h -
        actualHeight -
        //idx * CORRECTION_FACTOR;
        idx;
      isInRectangle = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  } else if (printableAreaShapeType === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;
    while (isInEllipse === false) {
      newY =
        productStore.drawPoints().y +
        productStore.drawPoints().ry -
        actualHeight -
        //idx * CORRECTION_FACTOR;
        idx;
      isInEllipse = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableAreaShapeType,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  }

  return newY;
};
